module.exports = __webpack_public_path__ + "static/media/pencilEdit.f08f2616.svg";